import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Role gate for routes that require a specific platform authz role (the
 * backend's `requireRole('admin')` convention — see
 * backend/src/middleware/auth.js). Wrap routes with it INSIDE a
 * `<ProtectedRoute />` group so authentication is already guaranteed:
 *
 *   <Route element={<ProtectedRoute />}>
 *     <Route element={<RequireRole role="admin" />}>
 *       <Route path="/tenant-cafeteria-management" element={<TenantCafeteriaPage />} />
 *     </Route>
 *   </Route>
 *
 * A signed-in user whose role doesn't match is blocked (redirected to the
 * themed 403 page), never merely hidden — page access must be enforced, not
 * just menu-item visibility.
 */
export default function RequireRole({ role }) {
  const { user } = useAuth();
  const allowed = Array.isArray(role) ? role : [role];

  if (!user || !allowed.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
